import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { CheckIcon } from '@heroicons/react/24/outline';
import tamaraLogoEn from '../../../assets/images/tamara-en.png';
import tamaraLogoAr from '../../../assets/images/tamara-ar.png';

interface TamaraPaymentOptionProps {
  name: string;
  description: string;
  isSelected: boolean;
  onSelect: (name: string) => void;
}

export default function TamaraPaymentOption({
  name,
  description,
  isSelected,
  onSelect,
}: TamaraPaymentOptionProps) {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const tamaraLogo = currentLanguage === 'ar' ? tamaraLogoAr : tamaraLogoEn;

  const handleSelect = () => {
    onSelect(name);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleSelect();
    }
  };

  return (
    <div
      className={classNames(
        'mb-2 cursor-pointer p-4 rounded-lg border border-gray-200 bg-white shadow-sm',
        { 'border-primary border-2': isSelected },
      )}
      onClick={handleSelect}
      onKeyDown={handleKeyDown}
      role='button'
      tabIndex={0}
      aria-pressed={isSelected}
    >
      <div className='flex items-center h-10'>
        <img
          src={tamaraLogo}
          alt='Tamara'
          className='h-6 w-auto mr-2 ml-4'
        />
        <div className='flex-1'>
          <p className='text-sm font-medium text-black'>
            {description}
            {' '}
          </p>
        </div>
        {isSelected ? (
          <CheckIcon aria-hidden='true' className='h-6 w-6 text-primary' />
        ) : (
          <span className='text-sm text-gray-500'>{t('account.paymentMethods.selectMethod')}</span>
        )}
      </div>
    </div>
  );
}
